export default __webpack_public_path__ + "static/media/Ballroll_00195.dd444a30.png";